import { createContext } from 'preact';
import store, { RootState } from '../store/store';
export const StoreContext = createContext<RootState>(store.getState());
